import { ApiStatus } from '../../api/constants/ApiConstants'

const { initial } = ApiStatus

export default {
  home: {},
  homeLoadedStatus: initial
}
